/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Components.Controls {
    "use strict";

    import FreezeSettingEnum = Meevo.Model.FreezeSettingEnum;

    export class MeevoMembershipIndicator implements angular.IDirective {
        dataService: Meevo.Components.BaseClasses.IDataService;
        appSettings: Meevo.Components.Common.IAppSettings;
        securityService: Meevo.Components.Common.ISecurityService;
        $translate: angular.translate.ITranslateService;
        $rootScope: ng.IRootScopeService;
        restrict = "E";
        scope = {
            clientId: "=",
            showLocation: "=showLocation",
            isHeader: "=?",
            clientMembershipId: "=?",
            dashboardElement: "=?",
        };

        templateUrl = "app/components/controls/clientMembershipIndicatorTemplate.html";

        link = (scope: any) => {
            let clientIdList = [];
            let params = {};
            let translate = this.$translate;
            let isLoaded = false;
            if (_.isUndefined(scope.dashboardElement)) scope.dashboardElement = false;

            scope.isCancelled = false;
            scope.showMemberDropdown = false;

            let uri = `/${Meevo.AppSettings.Default.API_ROOT}/Membership/Client/StatusIndicator/List`;

            var clientMembershipEditKey = Meevo.Components.Common.SecurityKeys.MEMBERSHIP_MEMBERSHIPMANAGER_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE;

            this.securityService.checkSecurityKey(clientMembershipEditKey).then(result => {
                scope.canEditClientMembership = result === Meevo.Model.SecurityAccessEnum.Grant;
            });

            scope.internalClientMembershipId = scope.clientMembershipId;

            var vm = this;
            scope.sendToMembership = function() {
                if (!scope.internalClientMembershipId) {
                    return;
                }

                var actionStateParam = Meevo.Model.MaintenanceFormState.Readonly;
                if (scope.canEditClientMembership) {
                    actionStateParam = Meevo.Model.MaintenanceFormState.Editing;
                }

                vm.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                    stateName: vm.appSettings.ROUTE_NAMES.membershipManager,
                    stateParams: {
                        callback: null,
                        callbackState: null,
                        targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                        actionState: actionStateParam,
                        id: scope.internalClientMembershipId
                    },
                });

                vm.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_SEARCH_MENU);
            }

            scope.fnDereg = scope.$watch('clientId', (clientId, oldClientId) => {
                clientIdList = [scope.clientId];
                params = {
                    clientIds: clientIdList
                };

                scope.hasMembership = false;

                if (!isLoaded) {
                    oldClientId = undefined;
                }

                if (clientId && clientId != oldClientId) {
                    scope.isMembershipExperired = false;
                    return vm.dataService.customMethodData(uri, 'POST', '', params)
                        .then((response) => {
                            if (response && response.data && response.data.length > 0) {
                                isLoaded = true;
                                scope.handleClientMembership(response.data[0]);
                            }
                        });
                }
            });

            scope.handleClientMembership = (clientMembership) => {
                if (!clientMembership) {
                    scope.hasMembership = false;
                    return;
                }

                scope.internalClientMembershipId = scope.clientMembershipId = clientMembership.clientMembershipId;
                scope.membershipDisplayName = clientMembership.membershipDisplayName;
                scope.homeLocationName = clientMembership.homeLocationName;
                scope.accruedServicesRemainingCount = clientMembership.accruedServicesRemainingCount;
                scope.registerNote = clientMembership.registerNote;
                scope.bookingNote = clientMembership.bookingNote;

                if (clientMembership.clientMembershipIndicatorStatusEnum) {
                    switch (clientMembership.clientMembershipIndicatorStatusEnum) {
                        case Meevo.Model.ClientMembershipIndicatorStatusEnum.DueToExpire:
                            scope.membershipIndicatorUrl = "assets/images/icons/membership_expire30days.svg";
                            scope.statusToolTip = translate.instant("LABEL_TOOLTIP_MEMBERSHIP_DUETOEXPIRE");
                            break;

                        case Meevo.Model.ClientMembershipIndicatorStatusEnum.Expired:
                            scope.isMembershipExperired = true;
                            scope.membershipIndicatorUrl = "assets/images/icons/membership_expired.svg";
                            scope.statusToolTip = translate.instant("LABEL_TOOLTIP_MEMBERSHIP_EXPIRED");
                            break;

                        case Meevo.Model.ClientMembershipIndicatorStatusEnum.Initial90:
                            scope.membershipIndicatorUrl = "assets/images/icons/membership_first90days.svg";
                            scope.statusToolTip = translate.instant("LABEL_TOOLTIP_MEMBERSHIP_INITIAL90");
                            break;

                        case Meevo.Model.ClientMembershipIndicatorStatusEnum.Frozen:
                            scope.membershipIndicatorUrl = this.clientMembershipService
                                .getClientMembershipIndicatorEnumIcon(clientMembership.clientMembershipIndicatorEnum);

                            scope.statusToolTip = translate.instant("LABEL_TOOLTIP_MEMBERSHIP_FROZEN");
                            break;

                        case Meevo.Model.ClientMembershipIndicatorStatusEnum.InCancellation:
                            scope.isCancelled = true;
                            scope.membershipIndicatorUrl = "assets/images/icons/membership_futuretermdate.svg";
                            scope.statusToolTip = translate.instant("LABEL_TOOLTIP_MEMBERSHIP_INCANCELLATION");
                            break;

                        case Meevo.Model.ClientMembershipIndicatorStatusEnum.NonCounting:
                            scope.membershipIndicatorUrl = "assets/images/icons/membership_noncounting.svg";
                            scope.statusToolTip = translate.instant("LABEL_TOOLTIP_MEMBERSHIP_NONCOUNTING");
                            break;

                        case Meevo.Model.ClientMembershipIndicatorStatusEnum.WithinInitialTerm:
                            scope.membershipIndicatorUrl = "assets/images/icons/membership_original.svg";
                            scope.statusToolTip = translate.instant("LABEL_TOOLTIP_MEMBERSHIP_WITHININITIALTERM");
                            break;

                        case Meevo.Model.ClientMembershipIndicatorStatusEnum.Error:
                            scope.membershipIndicatorUrl = "assets/images/icons/membership_pmtdidnotprocess.svg";
                            scope.statusToolTip = translate.instant("LABEL_TOOLTIP_MEMBERSHIP_ERROR");
                            break;

                        case Meevo.Model.ClientMembershipIndicatorStatusEnum.InRenewal:
                            scope.membershipIndicatorUrl = "assets/images/icons/membership_renewpastterm.svg";
                            scope.statusToolTip = translate.instant("LABEL_TOOLTIP_MEMBERSHIP_INRENEWAL");
                            break;

                        case Meevo.Model.ClientMembershipIndicatorStatusEnum.Suspended:
                            scope.membershipIndicatorUrl = "assets/images/icons/membership_suspended.svg";
                            scope.statusToolTip = translate.instant("LABEL_TOOLTIP_MEMBERSHIP_SUSPENDED");
                            break;

                        case Meevo.Model.ClientMembershipIndicatorStatusEnum.CCDueToExpire:
                            scope.membershipIndicatorUrl = "assets/images/icons/membership_ccexpiring.svg";
                            scope.statusToolTip = translate.instant("LABEL_TOOLTIP_MEMBERSHIP_CCDUETOEXPIRE");
                            break;

                        case Meevo.Model.ClientMembershipIndicatorStatusEnum.SoldToday:
                            scope.membershipIndicatorUrl = "assets/images/icons/membership_firstday.svg";
                            scope.statusToolTip = translate.instant("LABEL_TOOLTIP_MEMBERSHIP_SOLDTODAY");
                            break;
                    }
                    scope.hasMembership = true;
                } else {
                    scope.hasMembership = false;
                }
            }


            scope.$on('$destroy', () => {
                scope.fnDereg();
            });
        }

        constructor($rootScope: ng.IRootScopeService,
                    appSettings: Meevo.Components.Common.IAppSettings,
                    dataService: Meevo.Components.BaseClasses.IDataService,
                    securityService: Meevo.Components.Common.ISecurityService,
                    $translate: angular.translate.ITranslateService,
                    private clientMembershipService: Meevo.Components.Common.ClientMembershipDataService) {
            this.dataService = dataService;
            this.$rootScope = $rootScope;
            this.appSettings = appSettings;
            this.securityService = securityService;
            this.$translate = $translate;
        }

        static factory(): angular.IDirectiveFactory {
            let directive = ($rootScope: ng.IRootScopeService,
                appSettings: Meevo.Components.Common.IAppSettings,
                dataService: Meevo.Components.BaseClasses.IDataService,
                securityService: Meevo.Components.Common.ISecurityService,
                $translate: angular.translate.ITranslateService,
                clientMembershipService: Meevo.Components.Common.ClientMembershipDataService) => {
                return new MeevoMembershipIndicator($rootScope, appSettings, dataService, securityService, $translate, clientMembershipService);
            }

            directive.$inject = [
                "$rootScope",
                "meevo.AppSettings",
                "meevo.components.common.DataService",
                "meevo.components.common.SecurityService",
                "$translate",
                "meevo.components.common.ClientMembershipDataService",
            ];
            return directive;
        }
    }

    angular.module('meevo.components.controls').directive("meevoMembershipIndicator", MeevoMembershipIndicator.factory());
}
